(function () {
    var pwaPoCApp = angular.module('PWAPoCApp', ['ui.router', 'LocalForageModule', 'kendo.directives', 'kendo.window', 'leaflet-directive', 'bc.AngularKeypad', 'ngStorage']).value('THROTTLE_MILLISECONDS', null);

    pwaPoCApp.config(['$locationProvider', '$httpProvider', '$localForageProvider', function ($locationProvider, $httpProvider, $localForageProvider) {
        $locationProvider.html5Mode(true);
        $httpProvider.interceptors.push('authInterceptorService');
        $httpProvider.interceptors.push('logInterceptorService');
        $httpProvider.interceptors.push('offlineInterceptor');
    }]);

    pwaPoCApp.run(appInit);

    appInit.$inject = [
        '$q', '$rootScope', '$state', '$window', '$timeout', '$localStorage', 'authService', 'cacheService', 'networkService',
        'healthInfoService', 'settingsService', 'callOrdersService', 'messagesService', 'routeStopUpdateChecker', 'updateQueue',
        'appSettings', 'orderDetailTypesService', 'areaService', 'bluetoothService', 'translateService'
    ];

    function appInit($q, $rootScope, $state, $window, $timeout, $localStorage, authService, cacheService, networkService,
        healthInfoService, settingsService, callOrdersService, messagesService, routeStopUpdateChecker, updateQueue,
        appSettings, orderDetailTypesService, areaService, bluetoothService, translateService
    ) {

        $rootScope.authData = {};
        $rootScope.showNavbar = false;
        $rootScope.$localStorage = $localStorage;
        $rootScope.translate = translateService.translate;

        $rootScope.debugPanelVisible = false;
        $rootScope.debugNetwork = [];

        $rootScope.isDayStartSurveyFilledCachePrefix = 'isDayStartSurveyFilled_';

        init();

        function init() {
            cacheService.migrate()
                .then(function () {
                    return authService.getAuthData();
                })
                .then(function (authData) {
                    $rootScope.authData = authData;

                    checkIfOnlineAndAuth().then(updateHealthInfo);

                    //Load settings for user
                    if ($rootScope.authData.isAuth) {
                        const requests = [
                            settingsService.getSettings(),
                            settingsService.getVehicleSettings(),
                            settingsService.getUserType(),
                            settingsService.getIsDataButtonsEnabled(),
                            settingsService.getVoltAdjustUrl(),
                            settingsService.getDriverLanguage(),
                            settingsService.getEnableWeight(),
                            settingsService.getBotekSettings(),
                            cacheService.get('_language')
                        ];

                        $q.all(requests).then(function (data) {
                            const [userSettings, vehicleSettings, userType, isDataButtonsEnabled, voltAdjustUrl, selectedLanguage, enableWeight, botekSettings, cachedLanguage] = data;
                            console.log('cachedLanguage', cachedLanguage)
                            $rootScope.userSettings = userSettings;
                            $rootScope.vehicleSettings = vehicleSettings;
                            $rootScope.userType = userType;
                            $rootScope.isDataButtonsEnabled = isDataButtonsEnabled;
                            $rootScope.voltAdjustUrl = voltAdjustUrl;
                            $rootScope.selectedLanguage = cachedLanguage || selectedLanguage;
                            $rootScope.enableWeight = enableWeight;
                            $rootScope.botekSettings = botekSettings;                            

                            if ($rootScope.userType === 'service') {
                                orderDetailTypesService.getOrderDetailTypes(true).then(function(orderDetailTypes) {
                                    $rootScope.orderDetailTypes = orderDetailTypes;
                                });
                            }

                            if ($rootScope.userType === 'underground' || $rootScope.userType === 'service') {
                                areaService.getAreas(true).then(function (areas) {
                                    $rootScope.areas = areas;
                                });
                            }
                            if (enableWeight && !botekSettings.enableBotekHyperionByLocationTime){
                                bluetoothService.attachBotekWeightUnitDevice(true);
                            }
                        });

                        callOrdersService.startPolling();
                        messagesService.startMessagePolling();
                        healthInfoService.startExpiredWrongRouteStopDeletionPolling();
                    }
                })
        }

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            $rootScope.activeOrderId = toParams.orderId;

            if (toState.name !== 'error') {
                if (browserNotSupported($window.navigator.userAgent)) {
                    event.preventDefault();

                    $state.transitionTo('error');
                }

                authService.getAuthData().then(function (authData) {
                    if (authData.isAuth) {
                        if (!authService.isUpToDate()) {
                            event.preventDefault();

                            authService.logout().then(function () {
                                $state.transitionTo('login');
                            }, function () {
                                $state.transitionTo('login');
                            })
                            .finally(function(){
                                cacheService.updateServiceWorker();
                            });
                        }

                        if (fromState.name === 'main.routeStops' || fromState.name === 'main.completedRouteStops') {
                            if (fromParams.customSequenceStart) {
                                toParams.customSequenceStart = fromParams.customSequenceStart;
                            }
                            if (toState.name === 'main.map') {
                                toParams.orderId = fromParams.orderId;
                                if (fromState.name === 'main.completedRouteStops') {
                                    toParams.completed = true;
                                }
                            }
                        } else if ($rootScope.userType === 'service' && toState.name === 'main.routeStops') {
                            orderDetailTypesService.clearSelectedOrderDetailTypes().then(function() {
                                $rootScope.$broadcast('orderDetailTypesFilterChanged', []);
                            });
                        }

                        if (toState.name === 'login') {
                            event.preventDefault();
                            transitionToCachedState();
                        }
                    } else if ((toState.name !== 'login')) {
                        event.preventDefault();
                        $state.transitionTo('login');
                    }
                });
            }
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            if (toState.name === 'login') {
                $rootScope.showNavbar = false;
            } else {
                $rootScope.showNavbar = true;
            }

            cacheApplicationState(toState, toParams);
            $rootScope.$broadcast('hideBusyIndicator');
        });

        var hasMediaDeviceInitialized = false,
            userHasMediaDevice = false;

        $rootScope.hasMediaDevice = function() {
            var deferred = $q.defer();

            if (navigator && navigator.mediaDevices) {
                if (hasMediaDeviceInitialized) {
                    deferred.resolve(userHasMediaDevice);
                } else {
                    navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: "environment" } } }).then(
                        function() {
                            userHasMediaDevice = true;
                            deferred.resolve(userHasMediaDevice);
                        }).catch(function() {
                        userHasMediaDevice = false;
                        deferred.resolve(userHasMediaDevice);
                    });
                }
            } else {
                deferred.resolve(false);
            }

            return deferred.promise;
        };

        $rootScope.connectionChanged = function() {
            if ($rootScope.ping) $timeout.cancel($rootScope.ping);
            if ($rootScope.healthInfoUpdate) $timeout.cancel($rootScope.healthInfoUpdate);

            checkIfOnlineAndAuth().then(updateHealthInfo);
        };

        function cacheApplicationState(toState, toParams) {
            if (!isRestorableState(toState)) {
                return;
            }

            $rootScope.$localStorage.applicationState = {
                stateName: toState.name,
                params: angular.copy(toParams || {})
            };
        }

        function transitionToCachedState() {
            var appState = $rootScope.$localStorage.applicationState;
            var stateName = appState && (appState.stateName || (appState.state && appState.state.name));
            var state = stateName && $state.get(stateName);

            if (isRestorableState(state)) {
                $state.go(stateName, appState.params || {});
            } else {
                delete $rootScope.$localStorage.applicationState;
                $state.go('main.orders');
            }
        }

        function isRestorableState(state) {
            return state &&
                !state.abstract &&
                state.name !== 'root' &&
                state.name !== 'login' &&
                state.name !== 'error';
        }

        function checkIfOnlineAndAuth() {
            var deferred = $q.defer();

            networkService.isOnline()
                .then(function (isOnline) {
                    $rootScope.isOnline = isOnline;

                    if ($rootScope.authData.token) {
                        if (isOnline) {
                            callOrdersService.startPolling();
                            healthInfoService.startExpiredWrongRouteStopDeletionPolling();
                            messagesService.startMessagePolling();
                            updateQueue.triggerUpdates();
                        } else {
                            callOrdersService.stopPolling();
                            messagesService.stopMessagePolling();
                            healthInfoService.stopExpiredWrongRouteStopDeletionPolling();
                        }

                        routeStopUpdateChecker.scheduleUpdates();
                    } else {
                        callOrdersService.stopPolling();
                        messagesService.stopMessagePolling();
                        healthInfoService.stopExpiredWrongRouteStopDeletionPolling();
                    }

                    deferred.resolve();
                })
                .finally(function () {
                    var timeoutMs = $rootScope.isOnline ? appSettings.ping.online : appSettings.ping.offline;
                    if ($rootScope.ping) $timeout.cancel($rootScope.ping);
                    $rootScope.ping = $timeout(checkIfOnlineAndAuth, timeoutMs);
                });

            return deferred.promise;
        }

        function updateHealthInfo() {
            if ($rootScope.isOnline && $rootScope.authData.token) healthInfoService.update();

            var timeoutMs = appSettings.healthInfoUpdateMs;
            if ($rootScope.healthInfoUpdate) $timeout.cancel($rootScope.healthInfoUpdate);
            $rootScope.healthInfoUpdate = $timeout(updateHealthInfo, timeoutMs);
        }
    }

    function browserNotSupported(userAgent) {
        return (userAgent.indexOf('MSIE ') > 0 || userAgent.indexOf('Trident/') > 0);
    }
})();
